import { styled } from 'styled-components';
import { IconPlus } from '@tabler/icons-react';

export const StyledPlusIcon = styled(IconPlus)`
    height: 20px;
    width: 20px;
`;
